import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3492aee6&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=3492aee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3492aee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3492aee6')) {
      api.createRecord('3492aee6', component.options)
    } else {
      api.reload('3492aee6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3492aee6&scoped=true&", function () {
      api.rerender('3492aee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/robot/index.vue"
export default component.exports